import { ViewConfig } from "@lib/views";
import { WorkspaceMembersColumn } from "@common/types/views/workspaceMembersView";
import { WorkspaceMembersRow } from "./workspaceMembersRow";
import { UserCell } from "./cells/UserCell";
import { EntitiesCell } from "./cells/EntitiesCell";
import { RoleCell } from "./cells/RoleCell";
import { LastActiveCell } from "./cells/LastActiveCell";
import { ActionsCell } from "./cells/ActionsCell";

export const workspaceMembersViewConfig: ViewConfig<
    WorkspaceMembersRow,
    WorkspaceMembersColumn,
    never
> = {
    columns: {
        [WorkspaceMembersColumn.USER]: {
            accessorKey: "id",
            name: "User",
            header: "User",
            immutable: true,
            cell: UserCell,
            minSize: 200,
            maxSize: 600,
        },
        [WorkspaceMembersColumn.ENTITIES]: {
            accessorKey: "id",
            name: "Entities",
            header: "Entities",
            cell: EntitiesCell,
            minSize: 100,
            maxSize: 300,
        },
        [WorkspaceMembersColumn.ROLE]: {
            accessorKey: "id",
            name: "Role",
            header: "Role",
            cell: RoleCell,
            minSize: 100,
            maxSize: 200,
        },
        [WorkspaceMembersColumn.LAST_ACTIVE]: {
            accessorKey: "id",
            name: "Last active",
            header: "Last active",
            cell: LastActiveCell,
            minSize: 100,
            maxSize: 200,
        },
        [WorkspaceMembersColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            immutable: true,
            hiddenFromSettings: true,
            cell: ActionsCell,
            minSize: 48,
            maxSize: 48,
        },
    },
};
